export default "__VITE_ASSET__D7uLz8TT__"